<template>
	<div class='steps el-steps el-steps--horizontal'>
		<div class='el-step is-horizontal'
		:class='{isFlex:item.index == stepList.length}'
		style='flex-basis:50%;margin-right:0;'
		:style="{
			'flexBasis':(item.index==stepList.length?0:50)+'%',
			'maxWidth':(item.index==stepList.length?(1/stepList.length)*100:100)+'%'
			}"
		v-for="(item,index) in stepList"
		:key='index'
		>
		<div class='el-step__head is-process'>
			<div class='el-step__line'>
				<i class='el-step__line-inner' style='transition-delay:0ms;border-width:0;width:0%;'></i>
			</div>
		</div>
		<div class='textCla'>
			<div  class='el-step__icon is-text' :class="{success:index<active,before:index>active, active:index==active}" @click="clickStep(index,stepFunction)">
				<div class='el-step__icon-inner'>
					<div class="title" v-if='index == active'>{{item.title1}}</div>
                    <div class="title" v-if="active > index">{{item.title2}}</div>
					<div class="title" v-if="active < index">{{item.title}}</div>
                </div>
			</div>
			<div style='background:#fff;z-index:1;line-height:36px;padding:0 5px;' :class="{successText:index<active}">
                <!-- {{item.title}} -->
            </div>
		</div>
		<!-- <p class='pTitle'>{{item.title}}</p> -->
		</div>
	</div>
</template>
<script>
	export default{
		methods:{
			//点击步骤条后回调
			clickStep(index,callback){
				if(callback) callback(index)
                // console.log(index,"index",callback,"callback");
			}
		},
		props:{
			active:{ type : Number,default:0},
			stepFunction:{type:Function,default:()=>{}},
			stepList:{type:Array, default:()=>[] }
		}
	}
</script>
<style lang='scss' scoped>
.el-steps {
	display:flex;
	justify-content: center;
}
.textCla{
	display:flex;
  align-items: center;
}
.steps{
	[class^=el-icon-]{
		margin-left:0;
		font-weight:700;
    color: #cd1231;
	}
}
.el-step__icon.is-text{
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 0 !important;
    border: 1px solid !important;
    border-radius: 5px !important;
    .el-step__icon-inner{
        width: 98px;
        height: 32px;
        line-height: 32px;
        font-weight:normal;
    }
}
.el-step:last-of-type.isFlex{
	flex-basis:auto !important;
	flex-shrink:0;
	flex-grow:0;
}
.el-step.is-horizontal .el-step__line{
	top:18px;
}
.success{
	background-color:#CD1231 !important;
	color:#fff;
}
.successText{
	color:#000;
}
.active{
	background-color:#f5f5f5 !important;
    border: 1px soild #CD1231;
	color:#CD1231;
}
.before{
    background-color: #FFFFFF;
    color: #BBBBBB;
    border: 1px soild #BBBBBB;
	// border-color:#f3f3f5 !important;
}
.pTitle{
	z-index:1;
	width:84px;
	margin-left:36px;
    margin-top:0;
	white-space:pre-wrap;
	color:#9b9b9b;
	font-size:12px;
}
</style>
